import React, { useState } from "react";
import { AnalyticsProvider, AnalyticsProviderUser } from "@storefront-core/analytics-web";
import { getUserInfo } from "../utlis/analytics.util";

const analyticsConfig = {
  segmentWebWriteKey: process.env.REACT_APP_SEGMENT_WEB_WRITE_KEY,
  segmentAppWriteKey: process.env.REACT_APP_SEGMENT_APP_WRITE_KEY,
  gtmId: process.env.REACT_APP_GTM_ID,
  debug: process.env.NODE_ENV === 'development',
};

interface Props {
  children: React.ReactNode;
}

export const AnalyticsProviderWithConfig: React.FC<Props> = ({ children }) => {
  const [userInfo] = useState<AnalyticsProviderUser | null>(
    () => getUserInfo()
  );

   const isAuthenticated = !!(userInfo?.id && userInfo.id.trim() !== "");

  return (
    <AnalyticsProvider
      config={analyticsConfig}
      user={userInfo}
      isAuthenticated={isAuthenticated}
    >
      {children}
    </AnalyticsProvider>
  );
};